/*
 * @Author: nf
 * @Date: 2024-11-17 19:38:41
 * @LastEditors: nf
 * @LastEditTime: 2024-11-19 17:55:00
 * @Description: 
 * @FilePath: \station-maint-bim-web\src\layout\project\menu\download-project\DownloadProjectModal.tsx
 */
import React, { useState } from 'react';
import { Modal, Spin, message } from 'antd';
import dayjs from 'dayjs';
import { getProjectDetail } from '@/api/project/project';

interface DownloadProjectModalProps {
    visible: boolean;
    onClose: () => void;
    projectUuid: string;
    newDownloadBackup: (projectUuid: string) => Promise<any>; // 使用你的真实方法
}

const DownloadProjectModal: React.FC<DownloadProjectModalProps> = ({ visible, onClose, projectUuid, newDownloadBackup }) => {
    const [loading, setLoading] = useState<boolean>(false);

    const handleDownload = () => {
        setLoading(true);
        getProjectDetail(projectUuid).then((resproject) => {
            newDownloadBackup(projectUuid).then((res) => {
                    message.success('导出结束');

                    // res.data 是后端返回的 Base64 字符串
                    const base64Data = res.data;
                    const binaryString = atob(base64Data); // 将 Base64 解码为二进制字符串
                    const byteArray = new Uint8Array(binaryString.length);

                    for (let i = 0; i < binaryString.length; i++) {
                        byteArray[i] = binaryString.charCodeAt(i);
                    }

                    const blob = new Blob([byteArray], { type: 'application/json' }); // 创建 Blob 对象
                    const url = window.URL.createObjectURL(blob);

                    const now = dayjs();
                    const formattedDate = now.format('YYYY_MM_DD_HH_mm_ss'); // 格式化文件名

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${resproject.data.name}_${formattedDate}.json`; // 指定下载文件名
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }).catch((e) => {
                    message.error('导出失败，请重试！');
                    console.log('导出失败，请重试！', e)
                }).finally(() => {
                    setLoading(false);
                    onClose(); // 下载完成或失败后关闭弹窗
                });
        }).catch((e) => {
            message.error('获取项目信息失败，请重试！');
            console.log('获取项目信息失败，请重试！', e)
        });
    };

    return (
        <Modal
            title="下载项目资料"
            visible={visible}
            onOk={handleDownload}
            onCancel={onClose}
            closable={!loading} // 下载中禁止关闭
            okButtonProps={{ disabled: loading }} // 下载中禁用确认按钮
            cancelButtonProps={{ disabled: loading }} // 下载中禁用取消按钮
        >
            <Spin spinning={loading} tip="处理中，请稍候...">
                <p>是否下载当前项目的所有文件？</p>
            </Spin>
        </Modal>
    );
};

export default DownloadProjectModal;
